module.exports = __webpack_public_path__ + "media/views/about/images/handshake_heart-b3e5aa87e1a1f77e5b87b222c049b05f.svg";